import { render, staticRenderFns } from "./basebeneficiosanses.vue?vue&type=template&id=3aaf8cb4"
import script from "./basebeneficiosanses.vue?vue&type=script&lang=js"
export * from "./basebeneficiosanses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports